import { FC, useEffect } from 'react';
import { Controller, UseFormReturn, useWatch } from 'react-hook-form';
import { ProductFormData } from '@src/types';
import { InputSelect, RadioGroup, RadioGroupItem } from '@features/ui';
import {
  accountMeetingPayoutRequirementsData,
  payoutDateEligibleTypeData,
  payoutRequestTriggerData,
} from '@features/admin/productsAddons/productsAddonsData.ts';
// import { PracticeAndPerformanceAccount } from '@features/admin/productsAddons/PracticeAndPerformanceAccount.tsx';

interface ProductAdditionalFormProps {
  disabled: boolean;
}
export const ProductAdditionalForm: FC<
  UseFormReturn<ProductFormData> & ProductAdditionalFormProps
> = ({ control, formState: { errors }, disabled, setValue }) => {
  const payoutRequestTrigger = useWatch({
    control,
    name: 'payout_request_trigger',
  });

  useEffect(() => {
    if (payoutRequestTrigger !== 'date_eligible') {
      setValue('payout_date_eligible_type', null);
    }
  }, [payoutRequestTrigger, setValue]);

  return (
    <div className={'text-xs mb-[82px] mt-[51px] lg:pl-[48px] pl-5'}>
      <div
        className={
          'flex lg:flex-row flex-col xl:w-[90%] w-full gap-x-[103px] gap-y-7 lg:items-start'
        }
      >
        <div className={'w-full lg:max-w-[560px] flex flex-col gap-y-1.5'}>
          <Controller
            control={control}
            name="payout_request_trigger"
            render={({ field }) => (
              <div className={'flex flex-col gap-y-1.5'}>
                <div
                  className={
                    'flex flex-wrap items-center gap-[18px] lg:gap-[44px] mb-2.5'
                  }
                >
                  <p>When does the user request the payout</p>
                  <RadioGroup
                    className={'flex flex-wrap gap-x-[18px] gap-y-2'}
                    value={field.value}
                    onValueChange={(value) => field.onChange(value)}
                  >
                    {payoutRequestTriggerData.map((item) => {
                      return (
                        <div
                          key={item.value}
                          className={'flex items-center gap-x-[18px]'}
                        >
                          <RadioGroupItem value={item.value} />
                          <p>{item.label}</p>
                        </div>
                      );
                    })}
                  </RadioGroup>
                </div>
                <p className={'text-red-500'}>
                  {errors.payout_request_trigger?.message}
                </p>
              </div>
            )}
          />
          <Controller
            control={control}
            name="payout_date_eligible_type"
            render={({ field }) => (
              <div
                className={
                  payoutRequestTrigger === 'date_eligible'
                    ? 'flex flex-col gap-[11px] mt-2 w-full lg:max-w-[420px]'
                    : 'hidden'
                }
              >
                <p>Date eligible mode</p>
                <InputSelect
                  className={'text-xs'}
                  disabled={disabled}
                  error={!!errors.payout_date_eligible_type?.message}
                  options={payoutDateEligibleTypeData}
                  placeholder="Select"
                  value={field.value ?? undefined}
                  onChange={(value) => field.onChange(value)}
                />
                <p className={'text-red-500'}>
                  {errors.payout_date_eligible_type?.message}
                </p>
              </div>
            )}
          />
        </div>
        <Controller
          control={control}
          name="action_after_payout"
          render={({ field }) => (
            <div className={'flex flex-1 flex-col gap-[11px]'}>
              <p>
                What happens to this account after meeting payout requirements
              </p>
              <InputSelect
                className={'text-xs'}
                disabled={disabled}
                error={!!errors.action_after_payout?.message}
                options={accountMeetingPayoutRequirementsData}
                placeholder="Select"
                value={field.value}
                onChange={(value) => field.onChange(value)}
              />
            </div>
          )}
        />
      </div>
      {/*<PracticeAndPerformanceAccount*/}
      {/*  control={control}*/}
      {/*  errors={errors}*/}
      {/*  setValue={setValue}*/}
      {/*  watch={watch}*/}
      {/*/>*/}
    </div>
  );
};
